import { useRef, useState } from "react";
import { LuChefHat } from "react-icons/lu";
import { TpvDialog } from "../../../components/TpvDialog";
import { formatMoney } from "../../../utils/pricing";

export const OrderReview = ({
  lines,
  total,
  amounts,
  customerName,
  deliveryName,
  number,
  onConfirm,
  onClose,
  homeDelivery = false,
}) => {
  const pending = useRef(false);
  const [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const count = lines.reduce(
    (sum, line) => sum + Number(line.quantity || 0),
    0,
  );
  const confirm = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      await onConfirm();
    } catch (e) {
      setError(
        e.message ||
          "No se pudo confirmar el pedido. Revisa su estado antes de repetir.",
      );
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  return (
    <TpvDialog
      eyebrow="CONFIRMAR PEDIDO"
      title={number ? `Pedido #${number} a cocina` : "Pedido a cocina"}
      subtitle={[
        customerName,
        deliveryName,
        `${count} ${count === 1 ? "artículo" : "artículos"}`,
      ]
        .filter(Boolean)
        .join(" · ")}
      onClose={onClose}
      busy={busy}
      className="tpvOrderReview tpvOrderReviewReference"
    >
      <div className="tpvOrderReviewBody">
        <ul>
          {lines.map((line, index) => (
            <li key={line.id || line.shoppingCartProductId || index}>
              <div>
                <strong>
                  {line.quantity} ×{" "}
                  {line.Product?.shortName ||
                    line.Product?.name ||
                    line.name ||
                    "Producto"}
                </strong>
                {line.info && (
                  <span className="shoppingProductMeta">{line.info}</span>
                )}
              </div>
              <strong>{formatMoney(line.lineTotalWithTax)}</strong>
            </li>
          ))}
        </ul>
        {error && <p role="alert">{error}</p>}
      </div>
      <div className="tpvOrderReviewSummary">
        <div className="tpvOrderReviewSubtotals">
          <span>
            Subtotal sin IVA <strong>{formatMoney(amounts?.subtotal)}</strong>
          </span>
          <span>
            Descuento <strong>{formatMoney(amounts?.discounts)}</strong>
          </span>
        </div>
        <div className="tpvOrderReviewTotal">
          <div>
            <small>TOTAL</small>
            <strong>{formatMoney(total)}</strong>
          </div>
          <span>
            {homeDelivery
              ? "El repartidor cobrará al entregar"
              : "Se cobra después"}
          </span>
        </div>
        <div className="tpvOrderReviewActions">
          <button type="button" disabled={busy} onClick={onClose}>
            Volver
          </button>
          <button type="button" disabled={busy} onClick={confirm}>
            <LuChefHat aria-hidden="true" />
            {busy ? "ENVIANDO…" : "ENVIAR A COCINA"}
          </button>
        </div>
      </div>
    </TpvDialog>
  );
};
